import React, { useState } from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { Link } from "react-router-dom";

const SelectRA = () => {
  const [selectOption, setSelectOption] = useState(false);
  const [buttonValu, setButtonValue] = useState("View Quotes");
  return (
    <div>
      <div className="custom-select">
        <h5
          className="custom-select-title"
          onClick={() => setSelectOption(false)}
        >
          {buttonValu}
        </h5>
        <span
          className={
            buttonValu !== "Request for Change"
              ? " select-icon"
              : " long-text select-icon"
          }
          onClick={() => setSelectOption(true)}
        >
          <ArrowDropDownIcon />
        </span>
        {selectOption && (
          <div className="option" onClick={() => setSelectOption(false)}>
            <button
              onClick={(e) => setButtonValue(e.target.value)}
              value="Confirm"
            >
              <Link to={`/siteadmin/quotes`}> View Quotes</Link>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectRA;
